import React, { useEffect, useState } from "react"
import { GstStateCodes } from "constants/layout"
import { get, post } from "helpers/api_helper"
import { INVOICE_CONFIG } from "helpers/url_helper"
import Notifications from "components/Notifications"

const InvoiceSettings = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => { getInvoice(); }, [])

    const getInvoice = async () => {
        setLoading(true);
        setData(null);
        const res = await get(INVOICE_CONFIG);
        if (res.status === 200) {
            setData({
                ...res?.response,
                invoice_edit_approval: res?.response?.invoice_edit_approval !== undefined
                    ? (res.response.invoice_edit_approval === true || res.response.invoice_edit_approval === "true" || res.response.invoice_edit_approval === 1 || res.response.invoice_edit_approval === "1")
                    : true
            });
        }
        setLoading(false);
    }

    const updateInvoiceCall = async () => {
        setSaving(true);
        const res = await post(INVOICE_CONFIG, data);
        if (res.status === 200) Notifications("Invoice settings updated!", "success");
        else Notifications("Failed to update.", "error");
        setSaving(false);
    }

    const set = (key, val) => setData(prev => ({ ...prev, [key]: val }));
    const setBank = (key, val) => setData(prev => ({ ...prev, bank: { ...prev.bank, [key]: val } }));
    const inp = { width:"100%", padding:"9px 12px", border:"1px solid #e2e8f0", borderRadius:"8px", fontSize:"13px", outline:"none", background:"#fff" };
    const lbl = { fontSize:"12px", fontWeight:"600", color:"#64748b", marginBottom:"5px", display:"block", textTransform:"uppercase", letterSpacing:"0.4px" };
    const box = { background:"#f8fafc", borderRadius:"10px", padding:"20px", marginBottom:"20px", border:"1px solid #e2e8f0" };

    if (loading) return (
        <div style={{ textAlign:"center", padding:"40px" }}>
            <i className="fas fa-spinner fa-spin text-primary" style={{ fontSize:"24px" }}></i>
            <p style={{ marginTop:"10px", color:"#94a3b8", fontSize:"13px" }}>Loading invoice settings...</p>
        </div>
    );

    return (
        <div>
            {/* Company identity for invoice */}
            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-id-card text-primary"></i> Invoice Identity
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px", marginBottom:"16px" }}>
                    <div>
                        <label style={lbl}>Company Name (on Invoice)</label>
                        <input style={inp} type="text" value={data?.title || ""} onChange={e => set("title", e.target.value)} placeholder="DG Dental Lab Pvt. Ltd." />
                    </div>
                    <div>
                        <label style={lbl}>Invoice Logo</label>
                        <input style={{ ...inp, padding:"6px 12px" }} type="file" accept="image/*" />
                        <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"4px" }}>Printed on invoice header</div>
                    </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"16px" }}>
                    <div>
                        <label style={lbl}>Contact Number</label>
                        <input style={inp} type="text" value={data?.tel || ""} onChange={e => set("tel", e.target.value)} placeholder="9876543210" />
                    </div>
                    <div>
                        <label style={lbl}>Email</label>
                        <input style={inp} type="email" value={data?.email || ""} onChange={e => set("email", e.target.value)} placeholder="accounts@lab.com" />
                    </div>
                    <div>
                        <label style={lbl}>Website</label>
                        <input style={inp} type="text" value={data?.website || ""} onChange={e => set("website", e.target.value)} placeholder="www.yourlab.com" />
                    </div>
                </div>
            </div>

            {/* GST / Tax */}
            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-receipt text-primary"></i> GST & Tax Details
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px" }}>
                    <div>
                        <label style={lbl}>State</label>
                        <select style={inp} value={data?.gst_state_code || ""} onChange={e => {
                            const opt = e.target.options[e.target.selectedIndex];
                            set("state", opt.text);
                            set("gst_state_code", e.target.value);
                        }}>
                            {GstStateCodes.map((v, i) => <option value={v.code} key={i}>{v.state}</option>)}
                        </select>
                        {data?.state && <div style={{ fontSize:"11px", color:"#64748b", marginTop:"4px" }}>{data.state} — GST Code: <strong>{data.gst_state_code}</strong></div>}
                    </div>
                    <div>
                        <label style={lbl}>GST Number</label>
                        <input style={inp} type="text" value={data?.gst || ""} onChange={e => set("gst", e.target.value.toUpperCase())} placeholder="27AABCU9603R1ZX" maxLength={15} />
                        <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"4px" }}>15-digit GST Identification Number</div>
                    </div>
                </div>
            </div>

            {/* Bank Details */}
            <div style={box}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"16px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-bank text-primary"></i> Bank Details
                    <span style={{ fontSize:"11px", color:"#94a3b8", fontWeight:"400", marginLeft:"4px" }}>Printed at the bottom of invoice</span>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px", marginBottom:"16px" }}>
                    <div>
                        <label style={lbl}>Bank Name</label>
                        <input style={inp} type="text" value={data?.bank?.bank || ""} onChange={e => setBank("bank", e.target.value)} placeholder="State Bank of India" />
                    </div>
                    <div>
                        <label style={lbl}>Account Number</label>
                        <input style={inp} type="text" value={data?.bank?.account || ""} onChange={e => setBank("account", e.target.value)} placeholder="00112345678901" />
                    </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px" }}>
                    <div>
                        <label style={lbl}>IFSC Code</label>
                        <input style={inp} type="text" value={data?.bank?.ifscode || ""} onChange={e => setBank("ifscode", e.target.value.toUpperCase())} placeholder="SBIN0001234" maxLength={11} />
                    </div>
                    <div>
                        <label style={lbl}>Branch</label>
                        <input style={inp} type="text" value={data?.bank?.branch || ""} onChange={e => setBank("branch", e.target.value)} placeholder="Mumbai Main Branch" />
                    </div>
                </div>
            </div>

            {/* Invoice Approval & Permissions */}
            <div style={{ ...box, marginBottom:"24px" }}>
                <div style={{ fontWeight:"700", fontSize:"13px", color:"#334155", marginBottom:"4px", display:"flex", alignItems:"center", gap:"8px" }}>
                    <i className="bx bx-shield-quarter text-primary"></i> Invoice Approval & Permissions
                </div>
                <div style={{ fontSize:"11px", color:"#94a3b8", marginBottom:"16px" }}>Control invoice modification and cancellation approval workflows</div>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 0" }}>
                    <div>
                        <div style={{ fontWeight:"600", fontSize:"13px", color:"#1e293b", display:"flex", alignItems:"center", gap:"8px" }}>
                            Invoice Edit & Cancel Approval Workflow
                            <span style={{
                                fontSize: "10px",
                                padding: "2px 8px",
                                borderRadius: "10px",
                                fontWeight: "600",
                                background: data?.invoice_edit_approval ? "#dcfce7" : "#f1f5f9",
                                color: data?.invoice_edit_approval ? "#15803d" : "#64748b"
                            }}>
                                {data?.invoice_edit_approval ? "Active" : "Off"}
                            </span>
                        </div>
                        <div style={{ fontSize:"11px", color:"#94a3b8", marginTop:"2px" }}>
                            When turned on, non-admin users must request admin approval before modifying or cancelling an invoice. When turned off, users can modify and cancel invoices directly without approval.
                        </div>
                    </div>
                    <div onClick={() => set("invoice_edit_approval", !data?.invoice_edit_approval)} style={{ width:"44px", height:"24px", borderRadius:"12px", cursor:"pointer", background: data?.invoice_edit_approval ? "#2563eb" : "#cbd5e1", transition:"background 0.2s", position:"relative", flexShrink:0 }}>
                        <div style={{ width:"18px", height:"18px", borderRadius:"50%", background:"#fff", position:"absolute", top:"3px", transition:"left 0.2s", left: data?.invoice_edit_approval ? "23px" : "3px", boxShadow:"0 1px 3px rgba(0,0,0,0.2)" }} />
                    </div>
                </div>
            </div>

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <button onClick={getInvoice} style={{ padding:"9px 18px", background:"#f8fafc", color:"#64748b", border:"1px solid #e2e8f0", borderRadius:"8px", fontWeight:"600", fontSize:"13px", cursor:"pointer", display:"flex", alignItems:"center", gap:"6px" }}>
                    <i className="mdi mdi-refresh" /> Reload
                </button>
                <button onClick={updateInvoiceCall} disabled={saving} style={{ padding:"10px 24px", background:"#2563eb", color:"#fff", border:"none", borderRadius:"8px", fontWeight:"700", fontSize:"13px", cursor:"pointer", display:"flex", alignItems:"center", gap:"8px" }}>
                    {saving ? <><i className="fas fa-spinner fa-spin" /> Saving...</> : <><i className="bx bx-save" /> Save Invoice Settings</>}
                </button>
            </div>
        </div>
    );
}

export default InvoiceSettings;
